import React, { ComponentProps } from "react";
import { OverlayTrigger, Icon } from "banco-components";

type OverlayProps = ComponentProps<typeof OverlayTrigger>

export const Overlay = (props: OverlayProps) => {
  const { children, ...rest } = props;
  return (
    <OverlayTrigger
      offset={ [250, 250] }
      { ...rest }
    >
      { children }
    </OverlayTrigger>
  );
};

type OverlayQuestionProps = Omit<OverlayProps, "children">
const Question = (props: OverlayQuestionProps) => {
  return (
    <Overlay { ...props }>
      <span>
        <Icon.Question/>
      </span>
    </Overlay>
  );
};
const QuestionInText = (props: OverlayQuestionProps) => {
  return (
    <Overlay { ...props }>
      <span
        className={ "d-inline-flex align-items-center align-middle position-relative " }
        style={ { top: "-0.06em" } }
      >
        <Icon.Question/>
      </span>
    </Overlay>
  );
};
const QuestionH2Tag = (props: OverlayQuestionProps) => {
  return (
    <Overlay { ...props }>
      <div className="d-inline-flex align-center position-absolute mt-3">
        <Icon.Question/>
      </div>
    </Overlay>
  );
};
Question.displayName = "Overlay.Question";
Overlay.Question = Question;
Overlay.QuestionH2Tag = QuestionH2Tag;
Overlay.QuestionInText = QuestionInText;

type OverlayInfoProps = Omit<OverlayProps, "children">
const Info = (props: OverlayInfoProps) => {
  return (
    <Overlay { ...props }>
      <div style={ {
        display: "inline-flex",
        alignItems: "center"
      } }>
        <Icon.Info/>
      </div>
    </Overlay>
  );
};
Question.displayName = "Overlay.Info";
Overlay.Info = Info;

